import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GetTranslationService {

  constructor(
    private translate: TranslateService
  ) { }

  async getTranslate(key: string): Promise<string> {
    return new Promise((resolve) => {
      this.translate.get(key).subscribe(data => {
        resolve(data);
      });
    });
  }
}
